import React, { createContext, useContext, useMemo, useState, ReactNode } from 'react';

type UserType = {
  name: string;
  phone: string;
};

type UserContextType = {
  user: UserType;
  setUser: (user: UserType) => void;
  clearUser: () => void;
};

interface UserProviderProps {
  children: ReactNode;
}

const emptyUser: UserType = {
  name: '',
  phone: '',
};

const UserContext = createContext<UserContextType>({
  user: emptyUser,
  setUser: () => {},
  clearUser: () => {},
});

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState<UserType>(emptyUser);

  const value = useMemo(
    () => ({
      user,
      setUser,
      clearUser: () => setUser(emptyUser),
    }),
    [user]
  );

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = () => useContext(UserContext);
